var exports = {
  "element": "xe564cbfb--a23bbc--element",
  "element-type--small": "xe564cbfb--a23bbc--element-type--small",
  "element-type--normal": "xe564cbfb--a23bbc--element-type--normal",
  "element-type--big": "xe564cbfb--a23bbc--element-type--big",
  "element-type--h1": "xe564cbfb--a23bbc--element-type--h1",
  "element-type--h2": "xe564cbfb--a23bbc--element-type--h2",
  "element-type--h3": "xe564cbfb--a23bbc--element-type--h3",
  "element-font_size--0": "xe564cbfb--a23bbc--element-font_size--0",
  "element-font_size--10": "xe564cbfb--a23bbc--element-font_size--10",
  "element-font_size--12": "xe564cbfb--a23bbc--element-font_size--12",
  "element-font_size--14": "xe564cbfb--a23bbc--element-font_size--14",
  "element-font_size--16": "xe564cbfb--a23bbc--element-font_size--16",
  "element-font_size--18": "xe564cbfb--a23bbc--element-font_size--18",
  "element-font_size--22": "xe564cbfb--a23bbc--element-font_size--22",
  "element-font_size--28": "xe564cbfb--a23bbc--element-font_size--28",
  "element-font_size--36": "xe564cbfb--a23bbc--element-font_size--36",
  "element-line_height--normal": "xe564cbfb--a23bbc--element-line_height--normal",
  "element-line_height--0": "xe564cbfb--a23bbc--element-line_height--0",
  "element-line_height--12": "xe564cbfb--a23bbc--element-line_height--12",
  "element-line_height--14": "xe564cbfb--a23bbc--element-line_height--14",
  "element-line_height--16": "xe564cbfb--a23bbc--element-line_height--16",
  "element-line_height--18": "xe564cbfb--a23bbc--element-line_height--18",
  "element-line_height--20": "xe564cbfb--a23bbc--element-line_height--20",
  "element-line_height--22": "xe564cbfb--a23bbc--element-line_height--22",
  "element-line_height--24": "xe564cbfb--a23bbc--element-line_height--24",
  "element-line_height--28": "xe564cbfb--a23bbc--element-line_height--28",
  "element-line_height--36": "xe564cbfb--a23bbc--element-line_height--36",
  "element-line_height--46": "xe564cbfb--a23bbc--element-line_height--46",
  "element-color--transparent": "xe564cbfb--a23bbc--element-color--transparent",
  "element-color--black": "xe564cbfb--a23bbc--element-color--black",
  "element-color--white": "xe564cbfb--a23bbc--element-color--white",
  "element-color--gray_0": "xe564cbfb--a23bbc--element-color--gray_0",
  "element-color--gray_1": "xe564cbfb--a23bbc--element-color--gray_1",
  "element-color--gray_2": "xe564cbfb--a23bbc--element-color--gray_2",
  "element-color--gray_3": "xe564cbfb--a23bbc--element-color--gray_3",
  "element-color--gray_4": "xe564cbfb--a23bbc--element-color--gray_4",
  "element-color--gray_6": "xe564cbfb--a23bbc--element-color--gray_6",
  "element-color--blue": "xe564cbfb--a23bbc--element-color--blue",
  "element-color--blue_hover": "xe564cbfb--a23bbc--element-color--blue_hover",
  "element-color--blue_2": "xe564cbfb--a23bbc--element-color--blue_2",
  "element-color--pink": "xe564cbfb--a23bbc--element-color--pink",
  "element-color--green": "xe564cbfb--a23bbc--element-color--green",
  "element-color--green_darken": "xe564cbfb--a23bbc--element-color--green_darken",
  "element-color--red": "xe564cbfb--a23bbc--element-color--red",
  "element-color--red_1": "xe564cbfb--a23bbc--element-color--red_1",
  "element-color--orange": "xe564cbfb--a23bbc--element-color--orange",
  "element-color--yellow": "xe564cbfb--a23bbc--element-color--yellow",
  "element-color_hovered--transparent": "xe564cbfb--a23bbc--element-color_hovered--transparent",
  "element-color_hovered--black": "xe564cbfb--a23bbc--element-color_hovered--black",
  "element-color_hovered--white": "xe564cbfb--a23bbc--element-color_hovered--white",
  "element-color_hovered--gray_0": "xe564cbfb--a23bbc--element-color_hovered--gray_0",
  "element-color_hovered--gray_1": "xe564cbfb--a23bbc--element-color_hovered--gray_1",
  "element-color_hovered--gray_2": "xe564cbfb--a23bbc--element-color_hovered--gray_2",
  "element-color_hovered--gray_3": "xe564cbfb--a23bbc--element-color_hovered--gray_3",
  "element-color_hovered--gray_4": "xe564cbfb--a23bbc--element-color_hovered--gray_4",
  "element-color_hovered--blue": "xe564cbfb--a23bbc--element-color_hovered--blue",
  "element-color_hovered--blue_2": "xe564cbfb--a23bbc--element-color_hovered--blue_2",
  "element-color_hovered--blue_hover": "xe564cbfb--a23bbc--element-color_hovered--blue_hover",
  "element-color_hovered--pink": "xe564cbfb--a23bbc--element-color_hovered--pink",
  "element-color_hovered--green": "xe564cbfb--a23bbc--element-color_hovered--green",
  "element-color_hovered--green_darken": "xe564cbfb--a23bbc--element-color_hovered--green_darken",
  "element-color_hovered--red": "xe564cbfb--a23bbc--element-color_hovered--red",
  "element-color_hovered--red_1": "xe564cbfb--a23bbc--element-color_hovered--red_1",
  "element-color_hovered--orange": "xe564cbfb--a23bbc--element-color_hovered--orange",
  "element-color_hovered--yellow": "xe564cbfb--a23bbc--element-color_hovered--yellow",
  "element-display--none": "xe564cbfb--a23bbc--element-display--none",
  "element-display--block": "xe564cbfb--a23bbc--element-display--block",
  "element-display--inline": "xe564cbfb--a23bbc--element-display--inline",
  "element-display--inline-block": "xe564cbfb--a23bbc--element-display--inline-block",
  "element-display--flex": "xe564cbfb--a23bbc--element-display--flex",
  "element-display--inline-flex": "xe564cbfb--a23bbc--element-display--inline-flex",
  "element-width--auto": "xe564cbfb--a23bbc--element-width--auto",
  "element-width--inherit": "xe564cbfb--a23bbc--element-width--inherit",
  "element-width--wide": "xe564cbfb--a23bbc--element-width--wide",
  "element-visibility--visible": "xe564cbfb--a23bbc--element-visibility--visible",
  "element-visibility--hidden": "xe564cbfb--a23bbc--element-visibility--hidden",
  "element-visibility--inherit": "xe564cbfb--a23bbc--element-visibility--inherit",
  "element-vertical_align--middle": "xe564cbfb--a23bbc--element-vertical_align--middle",
  "element-vertical_align--bottom": "xe564cbfb--a23bbc--element-vertical_align--bottom",
  "element-vertical_align--top": "xe564cbfb--a23bbc--element-vertical_align--top",
  "element-text_decoration--inherit": "xe564cbfb--a23bbc--element-text_decoration--inherit",
  "element-text_decoration--none": "xe564cbfb--a23bbc--element-text_decoration--none",
  "element-text_decoration--underline": "xe564cbfb--a23bbc--element-text_decoration--underline",
  "element-text_decoration--overline": "xe564cbfb--a23bbc--element-text_decoration--overline",
  "element-text_decoration--line-through": "xe564cbfb--a23bbc--element-text_decoration--line-through",
  "element-text_transform--uppercase": "xe564cbfb--a23bbc--element-text_transform--uppercase",
  "element-text_align--inherit": "xe564cbfb--a23bbc--element-text_align--inherit",
  "element-text_align--left": "xe564cbfb--a23bbc--element-text_align--left",
  "element-text_align--right": "xe564cbfb--a23bbc--element-text_align--right",
  "element-text_align--center": "xe564cbfb--a23bbc--element-text_align--center",
  "element-text_align--justify": "xe564cbfb--a23bbc--element-text_align--justify",
  "element-overflow--inherit": "xe564cbfb--a23bbc--element-overflow--inherit",
  "element-overflow--auto": "xe564cbfb--a23bbc--element-overflow--auto",
  "element-overflow--visible": "xe564cbfb--a23bbc--element-overflow--visible",
  "element-overflow--hidden": "xe564cbfb--a23bbc--element-overflow--hidden",
  "element-overflow--scroll": "xe564cbfb--a23bbc--element-overflow--scroll",
  "element-word_wrap--inherit": "xe564cbfb--a23bbc--element-word_wrap--inherit",
  "element-word_wrap--normal": "xe564cbfb--a23bbc--element-word_wrap--normal",
  "element-word_wrap--break-word": "xe564cbfb--a23bbc--element-word_wrap--break-word",
  "element-white_space--inherit": "xe564cbfb--a23bbc--element-white_space--inherit",
  "element-white_space--normal": "xe564cbfb--a23bbc--element-white_space--normal",
  "element-white_space--nowrap": "xe564cbfb--a23bbc--element-white_space--nowrap",
  "element-white_space--pre": "xe564cbfb--a23bbc--element-white_space--pre",
  "element-white_space--pre-wrap": "xe564cbfb--a23bbc--element-white_space--pre-wrap",
  "element-white_space--pre-line": "xe564cbfb--a23bbc--element-white_space--pre-line",
  "element-font_weight--normal": "xe564cbfb--a23bbc--element-font_weight--normal",
  "element-font_weight--bold": "xe564cbfb--a23bbc--element-font_weight--bold",
  "element-font_weight--inherit": "xe564cbfb--a23bbc--element-font_weight--inherit",
  "element-border_box": "xe564cbfb--a23bbc--element-border_box",
  "element-ellipsis": "xe564cbfb--a23bbc--element-ellipsis",
  "element-row_ellipsis": "xe564cbfb--a23bbc--element-row_ellipsis",
  "element-display_mobile--none": "xe564cbfb--a23bbc--element-display_mobile--none",
  "element-display_mobile--block": "xe564cbfb--a23bbc--element-display_mobile--block",
  "element-display_mobile--inline": "xe564cbfb--a23bbc--element-display_mobile--inline",
  "element-display_mobile--inline-block": "xe564cbfb--a23bbc--element-display_mobile--inline-block",
  "element-display_mobile--flex": "xe564cbfb--a23bbc--element-display_mobile--flex",
  "element-display_mobile--inline-flex": "xe564cbfb--a23bbc--element-display_mobile--inline-flex",
  "element-font_size_mobile--0": "xe564cbfb--a23bbc--element-font_size_mobile--0",
  "element-font_size_mobile--10": "xe564cbfb--a23bbc--element-font_size_mobile--10",
  "element-font_size_mobile--12": "xe564cbfb--a23bbc--element-font_size_mobile--12",
  "element-font_size_mobile--14": "xe564cbfb--a23bbc--element-font_size_mobile--14",
  "element-font_size_mobile--16": "xe564cbfb--a23bbc--element-font_size_mobile--16",
  "element-font_size_mobile--18": "xe564cbfb--a23bbc--element-font_size_mobile--18",
  "element-font_size_mobile--22": "xe564cbfb--a23bbc--element-font_size_mobile--22",
  "element-font_size_mobile--28": "xe564cbfb--a23bbc--element-font_size_mobile--28",
  "element-font_size_mobile--36": "xe564cbfb--a23bbc--element-font_size_mobile--36",
  "element-line_height_mobile--0": "xe564cbfb--a23bbc--element-line_height_mobile--0",
  "element-line_height_mobile--12": "xe564cbfb--a23bbc--element-line_height_mobile--12",
  "element-line_height_mobile--14": "xe564cbfb--a23bbc--element-line_height_mobile--14",
  "element-line_height_mobile--16": "xe564cbfb--a23bbc--element-line_height_mobile--16",
  "element-line_height_mobile--18": "xe564cbfb--a23bbc--element-line_height_mobile--18",
  "element-line_height_mobile--20": "xe564cbfb--a23bbc--element-line_height_mobile--20",
  "element-line_height_mobile--22": "xe564cbfb--a23bbc--element-line_height_mobile--22",
  "element-line_height_mobile--24": "xe564cbfb--a23bbc--element-line_height_mobile--24",
  "element-line_height_mobile--28": "xe564cbfb--a23bbc--element-line_height_mobile--28",
  "element-line_height_mobile--36": "xe564cbfb--a23bbc--element-line_height_mobile--36",
  "element-line_height_mobile--46": "xe564cbfb--a23bbc--element-line_height_mobile--46",
  "element-display_phone--none": "xe564cbfb--a23bbc--element-display_phone--none",
  "element-display_phone--block": "xe564cbfb--a23bbc--element-display_phone--block",
  "element-display_phone--inline": "xe564cbfb--a23bbc--element-display_phone--inline",
  "element-display_phone--inline-block": "xe564cbfb--a23bbc--element-display_phone--inline-block",
  "element-display_phone--flex": "xe564cbfb--a23bbc--element-display_phone--flex",
  "element-display_phone--inline-flex": "xe564cbfb--a23bbc--element-display_phone--inline-flex",
  "element-display_tablet--none": "xe564cbfb--a23bbc--element-display_tablet--none",
  "element-display_tablet--block": "xe564cbfb--a23bbc--element-display_tablet--block",
  "element-display_tablet--inline": "xe564cbfb--a23bbc--element-display_tablet--inline",
  "element-display_tablet--inline-block": "xe564cbfb--a23bbc--element-display_tablet--inline-block",
  "element-display_tablet--flex": "xe564cbfb--a23bbc--element-display_tablet--flex",
  "element-display_tablet--inline-flex": "xe564cbfb--a23bbc--element-display_tablet--inline-flex",
  "element-font_size_desktop--0": "xe564cbfb--a23bbc--element-font_size_desktop--0",
  "element-font_size_desktop--10": "xe564cbfb--a23bbc--element-font_size_desktop--10",
  "element-font_size_desktop--12": "xe564cbfb--a23bbc--element-font_size_desktop--12",
  "element-font_size_desktop--14": "xe564cbfb--a23bbc--element-font_size_desktop--14",
  "element-font_size_desktop--16": "xe564cbfb--a23bbc--element-font_size_desktop--16",
  "element-font_size_desktop--18": "xe564cbfb--a23bbc--element-font_size_desktop--18",
  "element-font_size_desktop--22": "xe564cbfb--a23bbc--element-font_size_desktop--22",
  "element-font_size_desktop--28": "xe564cbfb--a23bbc--element-font_size_desktop--28",
  "element-font_size_desktop--36": "xe564cbfb--a23bbc--element-font_size_desktop--36",
  "element-line_height_desktop--0": "xe564cbfb--a23bbc--element-line_height_desktop--0",
  "element-line_height_desktop--12": "xe564cbfb--a23bbc--element-line_height_desktop--12",
  "element-line_height_desktop--14": "xe564cbfb--a23bbc--element-line_height_desktop--14",
  "element-line_height_desktop--16": "xe564cbfb--a23bbc--element-line_height_desktop--16",
  "element-line_height_desktop--18": "xe564cbfb--a23bbc--element-line_height_desktop--18",
  "element-line_height_desktop--20": "xe564cbfb--a23bbc--element-line_height_desktop--20",
  "element-line_height_desktop--22": "xe564cbfb--a23bbc--element-line_height_desktop--22",
  "element-line_height_desktop--24": "xe564cbfb--a23bbc--element-line_height_desktop--24",
  "element-line_height_desktop--28": "xe564cbfb--a23bbc--element-line_height_desktop--28",
  "element-line_height_desktop--36": "xe564cbfb--a23bbc--element-line_height_desktop--36",
  "element-line_height_desktop--46": "xe564cbfb--a23bbc--element-line_height_desktop--46",
  "element-display_desktop_max--none": "xe564cbfb--a23bbc--element-display_desktop_max--none",
  "element-display_desktop_max--block": "xe564cbfb--a23bbc--element-display_desktop_max--block",
  "element-display_desktop_max--inline": "xe564cbfb--a23bbc--element-display_desktop_max--inline",
  "element-display_desktop_max--inline-block": "xe564cbfb--a23bbc--element-display_desktop_max--inline-block",
  "element-display_desktop_max--flex": "xe564cbfb--a23bbc--element-display_desktop_max--flex",
  "element-display_desktop_max--inline-flex": "xe564cbfb--a23bbc--element-display_desktop_max--inline-flex",
};

module.exports = exports;
